import { defineComponent as z, ref as F, computed as N, provide as T, h as U } from "vue";
import D from "./ghl-ui.es941.js";
import { useRtl as j } from "./ghl-ui.es851.js";
import H from "./ghl-ui.es854.js";
import O from "./ghl-ui.es712.js";
import y from "./ghl-ui.es855.js";
import { useThemeClass as V } from "./ghl-ui.es857.js";
import { warn as k } from "./ghl-ui.es853.js";
import { createInjectionKey as _ } from "./ghl-ui.es896.js";
import $ from "./ghl-ui.es942.js";
import { call as p } from "./ghl-ui.es876.js";
const B = Object.assign(Object.assign({}, y.props), {
  defaultExpandedNames: {
    type: [Array, String],
    default: null
  },
  expandedNames: [Array, String],
  arrowPlacement: {
    type: String,
    default: "left"
  },
  accordion: {
    type: Boolean,
    default: !1
  },
  displayDirective: {
    type: String,
    default: "if"
  },
  triggerAreas: {
    type: Array,
    default: () => ["main", "extra", "arrow"]
  },
  onItemHeaderClick: [Function, Array],
  "onUpdate:expandedNames": [Function, Array],
  onUpdateExpandedNames: [Function, Array],
  // deprecated
  onExpandedNamesChange: {
    type: [Function, Array],
    validator: () => (process.env.NODE_ENV !== "production" && k("collapse", "`on-expanded-names-change` is deprecated, please use `on-update:expanded-names` instead."), !0),
    default: void 0
  }
}), K = _("n-collapse"), te = z({
  name: "Collapse",
  props: B,
  setup(t, {
    slots: E
  }) {
    const {
      mergedClsPrefixRef: s,
      inlineThemeDisabled: u,
      mergedRtlRef: v
    } = H(t), x = F(t.defaultExpandedNames), R = N(() => t.expandedNames), g = O(R, x), C = y("Collapse", "-collapse", D, $, t, s);
    function l(n) {
      const {
        "onUpdate:expandedNames": e,
        onUpdateExpandedNames: o,
        onExpandedNamesChange: r
      } = t;
      o && p(o, n), e && p(e, n), r && p(r, n), x.value = n;
    }
    function i(n) {
      const {
        onItemHeaderClick: e
      } = t;
      e && p(e, n);
    }
    function b(n, e, o) {
      const {
        accordion: r
      } = t, {
        value: c
      } = g;
      if (r)
        n ? (l([e]), i({
          name: e,
          expanded: !0,
          event: o
        })) : (l([]), i({
          name: e,
          expanded: !1,
          event: o
        }));
      else if (!Array.isArray(c))
        l([e]), i({
          name: e,
          expanded: !0,
          event: o
        });
      else {
        const a = c.slice(), f = a.findIndex((m) => e === m);
        ~f ? (a.splice(f, 1), l(a), i({
          name: e,
          expanded: !1,
          event: o
        })) : (a.push(e), l(a), i({
          name: e,
          expanded: !0,
          event: o
        }));
      }
    }
    T(K, {
      props: t,
      mergedClsPrefixRef: s,
      expandedNamesRef: g,
      slots: E,
      toggleItem: b
    });
    const A = j("Collapse", v, s), h = N(() => {
      const {
        common: {
          cubicBezierEaseInOut: n
        },
        self: {
          titleFontWeight: e,
          dividerColor: o,
          titlePadding: r,
          titleTextColor: c,
          titleTextColorDisabled: a,
          textColor: f,
          arrowColor: m,
          fontSize: w,
          titleFontSize: I,
          arrowColorDisabled: P,
          itemMargin: S
        }
      } = C.value;
      return {
        "--n-font-size": w,
        "--n-bezier": n,
        "--n-text-color": f,
        "--n-divider-color": o,
        "--n-title-padding": r,
        "--n-title-font-size": I,
        "--n-title-text-color": c,
        "--n-title-text-color-disabled": a,
        "--n-title-font-weight": e,
        "--n-arrow-color": m,
        "--n-arrow-color-disabled": P,
        "--n-item-margin": S
      };
    }), d = u ? V("collapse", void 0, h, t) : void 0;
    return {
      rtlEnabled: A,
      mergedTheme: C,
      mergedClsPrefix: s,
      cssVars: u ? void 0 : h,
      themeClass: d == null ? void 0 : d.themeClass,
      onRender: d == null ? void 0 : d.onRender
    };
  },
  render() {
    var t;
    return (t = this.onRender) === null || t === void 0 || t.call(this), U("div", {
      class: [`${this.mergedClsPrefix}-collapse`, this.rtlEnabled && `${this.mergedClsPrefix}-collapse--rtl`, this.themeClass],
      style: this.cssVars
    }, this.$slots);
  }
});
export {
  K as collapseInjectionKey,
  B as collapseProps,
  te as default
};
